// extracted by mini-css-extract-plugin
module.exports = {"url-input":"UrlFetch_url-input__3MhUF"};